import * as React from "react";
import MyOrder from "../../Login/Order/MyOrder/MyOrder";

import { Container } from "react-bootstrap";

const DashboardHome = () => {
  return (
    <Container>
      <MyOrder></MyOrder>
    </Container>
  );
};

export default DashboardHome;
